import * as analytics from "@/lib/analytics";

/**
 * PostHog events for tasks usage. Every mutation surface funnels through
 * these so event names/props stay consistent no matter where the action
 * happened; `source` is the surface, for adoption breakdowns.
 */
export type TaskEventSource = "tasks-page" | "task-detail" | "inbox" | "contact-sidebar";

export function trackTaskCreated(props: {
  gym: string;
  source: "tasks-page" | "contact" | "conversation";
  assigned: boolean;
  hasCustomer: boolean;
  hasDueDate: boolean;
  hasDescription: boolean;
  tags: number;
}) {
  analytics.track("Task Created", props);
}

export function trackTaskUpdated(
  gym: string,
  body: Record<string, unknown>,
  source: TaskEventSource,
) {
  analytics.track("Task Updated", {
    gym,
    source,
    fields: Object.keys(body).sort(),
    // Status transitions (completed, snoozed, ...) are the main usage
    // signal, so surface the new status as its own property.
    ...(typeof body.status === "string" ? { status: body.status } : {}),
  });
}

export function trackTaskDeleted(gym: string, source: TaskEventSource) {
  analytics.track("Task Deleted", { gym, source });
}

export function trackTasksPageViewed(gym: string, view: "list" | "board") {
  analytics.track("Tasks Page Viewed", { gym, view });
}

export function trackTasksViewChanged(gym: string, view: string) {
  analytics.track("Tasks View Changed", { gym, view });
}
